<template>
  <div class="like-rating">
    <div class="like-rating__likes" @click="changeLike">
      <icon-finger-up :isFill="hasLike"></icon-finger-up>
    </div>
    <div class="like-rating__counter"> 
        {{likesCount}} </div>
    <div class="like-rating__dislikes" @click="addDislike" v-if="dislikeMode">
      <icon-finger-up class="rotate"></icon-finger-up>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dislikeMode: {
      type: Boolean,
      default: false
    },
    likesCount: {
      type: Number,
      default: 0
    },
    hasLike:{
      type:Boolean,
      default: false
    }
  },
  methods:{
    changeLike(){
      if(this.hasLike)
      this.$emit('remove');  
      else
      this.$emit('like');
    }
  }
};
</script>

<style scoped>
.rotate {
  transform: rotate(180deg);
}
.like-rating {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.like-rating {
  cursor: pointer;
}
.like-rating__counter {
  background: #f5f5f6;
  border-radius: 0px 5px;
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  color: #006eff;
  width: 57px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>